import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchPurchaseOrderDetail(id) {
  const { data: raw } = await request.get(`/srm/purchase-order/${id}`);
  return parseVer4DetailResponse(raw);
}
